import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { outlinedButtonClasses } from '../Button';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconDefinition;
  iconClass?: string;
  title?: string;
  subtitle?: string;
}

const RectangleIconButton = (props: Props): JSX.Element => {
  const { className, icon, iconClass, onClick, subtitle, title, ...rest } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    // order matters for the classes
    <button
      type='button'
      className={'transition-all border-2 border-sapphire-50 bg-white cursor-pointer duration-500 rounded-xl h-28 w-44 '
        + `${outlinedButtonClasses}${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={`${title}${subtitle ? ` (${subtitle})` : ''}`}
      {...rest}
    >
      <div>
        <FontAwesomeIcon className={`${iconClass} text-emerald-100 z-10`} size='3x' icon={icon} />
      </div>
      {title && title?.length > 0 && (
        <div className='font-medium self-center'>
          {title}
        </div>
      )}
      {subtitle && subtitle?.length > 0 && (
        <div className='text-center text-[10px]'>
          {subtitle}
        </div>
      )}
    </button>
  );
};

export { RectangleIconButton };
